import { Routes } from '@angular/router';
import { ExpandableComponent } from '@ethervox/mcs'; // eslint-disable-line

export const mcsRoutes: Routes = [
  {
    path: '',
    component: ExpandableComponent,
  },
];
